<!--<div class="grid" *ngIf="newVersion">
   <div class="col-12 flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl">
      <p-tag icon="pi cm-alert" [value]="('NEW_RELEASE_WARNING' | translate)" severity="warning"></p-tag>
   </div>
</div>-->
<div class="grid" *ngIf="newVersionError" style="margin-bottom:15px;">
   <div class="col-12 flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl">
      <p-tag icon="pi cm-alert" [value]="('NEW_RELEASE_WARNING_ERROR' | translate)" severity="warning"></p-tag>
   </div>
</div>
<!--<div class="grid" *ngIf="newVersion && enableBeta">
   <div class="col-12 flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl">
      <p-tag icon="pi cm-alert" [value]="('NEW_RELEASE_BETA_WARNING' | translate)" severity="warning"></p-tag>
   </div>
</div>-->
<p-accordion [activeIndex]="0">
   <p-accordionTab *ngFor="let releaseNote of releaseNoteList">
      <ng-template pTemplate="header">
         <div class="flex align-items-center w-full"
            [class]="!onExtendedMobile() ? 'flex-row justify-content-between' : 'flex-column justify-content-center'">
            <div class="font-bold" [class]="!onExtendedMobile() ? '' : 'pb-1'">{{releaseNote.ReleaseVersion}}</div>
         </div>
      </ng-template>
      <p-panel>
         <div [innerHTML]="releaseNote.Text">
         </div>
      </p-panel>
   </p-accordionTab>
</p-accordion>
<div class="grid mt-3 mb-1 mx-1 flex justify-content-center align-items-center">
   <button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CLOSE' | translate }}"
      class="p-button-secondary text-xl font-normal mt-3 sm:mt-0 ml-0 sm:ml-1" [ngClass]="dynamicButtonWidth()">
   </button>
</div>